module.exports = __webpack_public_path__ + "media/images/emblems/Chatel-sur-Montsalvens-coat_of_arms-dccac6eb80c354da04f32587283089ef.svg";